import {rtkApi} from '../../apiSlice';
import {rtkActionHandler} from '../../rtkHandler';
import {
    CREATE_LOCATION,
    LOCATION_FILTERS,
    UPDATE_LOCATION_PROPS,
    UPDATE_LOCATION_STATUS
} from "@/redux/rtk/admin/locations/types";
import {
    createNewLocation,
    deleteLocation,
    getAllLocations,
    getAllLocationsForSelect,
    getLocation,
    updateLocation,
    updateLocationStatus
} from "@/redux/apis/admin/locations";

const apiWithPortalAdministrationTag = rtkApi.enhanceEndpoints?.({ addTagTypes: [] });

export const locationsApi = apiWithPortalAdministrationTag.injectEndpoints({
    endpoints: (builder) => ({
        getAllLocations: builder.mutation<any, LOCATION_FILTERS>({
            queryFn: async (data: LOCATION_FILTERS) => {
                return rtkActionHandler(getAllLocations(data));
            },
        }),
        getAllLocationsForSelect: builder.mutation<any, number>({
            queryFn: async (pid: number) => {
                return rtkActionHandler(getAllLocationsForSelect(pid));
            },
        }),
        createNewLocation: builder.mutation<any, CREATE_LOCATION>({
            queryFn: async (data: CREATE_LOCATION) => {
                return rtkActionHandler(createNewLocation(data));
            },
        }),
        updateLocation: builder.mutation<any, UPDATE_LOCATION_PROPS>({
            queryFn: async (data: UPDATE_LOCATION_PROPS) => {
                return rtkActionHandler(updateLocation(data));
            },
        }),
        deleteLocation: builder.mutation<any, number>({
            queryFn: async (uid: number) => {
                return rtkActionHandler(deleteLocation({uid}));
            },
        }),
        updateLocationStatus: builder.mutation<any, UPDATE_LOCATION_STATUS>({
            queryFn: async (data: UPDATE_LOCATION_STATUS) => {
                return rtkActionHandler(updateLocationStatus(data));
            },
        }),
        getLocation: builder.query<any, number>({
            queryFn: async (uid: number) => {
                return rtkActionHandler(getLocation({uid}));
            },
        }),
    })
})

export const {
    useGetAllLocationsMutation,
    useCreateNewLocationMutation,
    useUpdateLocationMutation,
    useDeleteLocationMutation,
    useUpdateLocationStatusMutation,
    useGetLocationQuery,
    useGetAllLocationsForSelectMutation
} = locationsApi